import { inject } from "@angular/core";
import { CanActivateFn, UrlTree } from "@angular/router";
import { from, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { UserAssignmentNavigationService } from "@core/services/user-assignment-navigation.service";
import { DomainService } from "@shared/services/domain/domain.service";

export const InductionFeatureGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const domainService: DomainService = inject(DomainService);
  const userAssignmentNavigation: UserAssignmentNavigationService = inject(UserAssignmentNavigationService);

  return from(domainService.ready).pipe(switchMap((): Observable<boolean | UrlTree> => {
    if (Boolean(domainService.featureFlags()["inductionCourses"])) return of(true);

    return userAssignmentNavigation.resolveDefaultHomeUrlTree$();
  }),
  );
};
